import IBreadcrumbItem from "./IBreadcrumbItem";
import deviceService from "../../services/deviceService";
import folderService from "../../services/folderService";
import i18next from "i18next";

const t = i18next.t;

async function LoadBreadcrumbs() {
    let path = window.location.pathname.toLowerCase();

    if (path === '/') {
        return [];
    }

    if (path.endsWith('/')) {
        path = path.substring(0, path.length - 1);
    }

    const parts = path.split('/');

    if (parts[0] === '') {
        parts.shift();
    }
    
    if (parts[0] === 'f' && parts.length > 1) {
        const id = parts[1];

        const crumbs = await LoadFolderBreadcrumbs(id);
        return crumbs;
      } else if (parts[0] === 'f' && parts.length === 1) {
        const item: IBreadcrumbItem = {
          text: t("folders.titles.folders"),
          href: '/f',
        };
  
        return [item];
      } else if (parts[0] === 'd' && parts.length > 1) {
        const id = parts[1];
        
        const crumbs = await LoadDeviceBreadcrumbs(id);
        return crumbs;
      } else if (parts[0] === 'd' && parts.length === 1) {
        const item: IBreadcrumbItem = {
          text: t("devices.titles.devices"),
          href: '/d',
        };
  
        return [item];
      }

      return [];
}

async function LoadFolderBreadcrumbs(folderId: string) {
    const crumbs: IBreadcrumbItem[] = [];
    let currentId = folderId;
  
    while (currentId) {
        const folder = await folderService.getFolderById(currentId);
        if (!folder) {
            break;
        }
        
        const crumb: IBreadcrumbItem = {
            text: folder.name,
            href: `/f/${folder.id}`
        };

        crumbs.unshift(crumb);
        currentId = folder.parentId!;
    }

    crumbs.unshift({
        text: t("folders.titles.folders"),
        href: '/f',
    });

    return crumbs;
}

async function LoadDeviceBreadcrumbs(deviceId: string) {
    const device = await deviceService.getDevice(deviceId);

    const crumbs: IBreadcrumbItem[] = [
        {
            text: t("devices.titles.devices"),
            href: '/d',
        },
        {
            text: device.name,
            href: `/d/${device.id}`
        }
    ];

    return crumbs;
}

export { LoadBreadcrumbs };